import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../../context/LanguageContext";
import { useWalletContext } from "../../../context/WalletContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { consumeOpenFreeAccountFlow } from "../../../utils/walletActivationNudge";
import { WalletIcon } from "../../../assets/icons/icon";
import InvoicePromoBanner from "../../container/Ucash/InvoicePromoBanner";

const ActivateWalletNudge = ({ className = "" }) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { EMIVerified } = useWalletContext();
  const [visible, setVisible] = useState(consumeOpenFreeAccountFlow);

  if (EMIVerified || !visible) return null;

  const handleActivateWallet = () => {
    triggerLogEvent(analytics, "activate_wallet_nudge_click");
    setVisible(false);
    navigate("/UCash");
  };

  return (
    <InvoicePromoBanner
      className={className}
      icon={<WalletIcon width={22} height={22} />}
      title={I18n.activate_your_wallet}
      subtitle={I18n.activate_wallet_note}
      ctaLabel={I18n.activate_wallet}
      ctaId="ActivateWalletNudgeCta"
      onCtaClick={handleActivateWallet}
    />
  );
};

export default ActivateWalletNudge;
